export enum FieldNames {
    Address1 = 'AD_ADDR1',
    Address2 = 'AD_ADDR2',
    UnitNo = 'DB_UNITNO',
    City = 'DB_CITY',
    State = 'DB_STATE',
    ZipCode = 'DB_ZIPCODE',
    CompPhoto = 'COMP_PHOTO',
    Id = 'ID',
    AnalysisOfPriorSale = 'CMPHIST_TXT1',
    AddendaWithSalesHistories = 'TADD_SALESHISTORIES',
    DataFactSheet = '_dataFactSheet',
    MlsImportName = 'MLS_IMPORT_NAME',
}
